import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.collection.content.length}}
  <ul
    class="select-kit-collection"
    aria-live="polite"
    role="menu"
    {{did-insert this.lock}}
    {{will-destroy this.unlock}}
  >
    {{#each this.collection.content as |item index|}}
      {{component
        (component-for-row this.collection.identifier item this.selectKit)
        index=index
        item=item
        value=this.value
        selectKit=this.selectKit
      }}
    {{/each}}
  </ul>
{{/if}}
*/
{
  "id": "eGhRZX3D",
  "block": "[[[41,[30,0,[\"collection\",\"content\",\"length\"]],[[[1,\"  \"],[11,\"ul\"],[24,0,\"select-kit-collection\"],[24,\"aria-live\",\"polite\"],[24,\"role\",\"menu\"],[4,[38,1],[[30,0,[\"lock\"]]],null],[4,[38,2],[[30,0,[\"unlock\"]]],null],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"collection\",\"content\"]]],null]],null],null,[[[1,\"      \"],[46,[28,[37,6],[[30,0,[\"collection\",\"identifier\"]],[30,1],[30,0,[\"selectKit\"]]],null],null,[[\"index\",\"item\",\"value\",\"selectKit\"],[[30,2],[30,1],[30,0,[\"value\"]],[30,0,[\"selectKit\"]]]],null],[1,\"\\n\"]],[1,2]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"item\",\"index\"],false,[\"if\",\"did-insert\",\"will-destroy\",\"each\",\"-track-array\",\"component\",\"component-for-row\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/select-kit/select-kit-collection.hbs",
  "isStrictMode": false
});